import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ATA.CONTROLE_SALDOS_ORGAO.BUSCAR_ORGAOS_USUARIO](context, idAta) {
		const { data } = await api.controleSaldosOrgao.buscarOrgaosUsuario(idAta)
		return data
	},
	async [actionTypes.ATA.CONTROLE_SALDOS_ORGAO.BUSCAR_POR_FILTRO](context, { filtros, paginacao }) {
		const { data } = await api.controleSaldosOrgao.buscarPorFiltro(filtros, paginacao)
		return data
	},
}
